<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M18 3C16.8954 3 16 3.89543 16 5C16 6.10457 16.8954 7 18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3ZM14 5C14 2.79086 15.7909 1 18 1C20.2091 1 22 2.79086 22 5C22 7.20914 20.2091 9 18 9C15.7909 9 14 7.20914 14 5Z"
    />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10ZM2 12C2 9.79086 3.79086 8 6 8C8.20914 8 10 9.79086 10 12C10 14.2091 8.20914 16 6 16C3.79086 16 2 14.2091 2 12Z"
    />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M18 17C16.8954 17 16 17.8954 16 19C16 20.1046 16.8954 21 18 21C19.1046 21 20 20.1046 20 19C20 17.8954 19.1046 17 18 17ZM14 19C14 16.7909 15.7909 15 18 15C20.2091 15 22 16.7909 22 19C22 21.2091 20.2091 23 18 23C15.7909 23 14 21.2091 14 19Z"
    />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.13251 13.3605C8.41058 12.8834 9.02282 12.7219 9.5 13L15.5 16.5C15.9772 16.7781 16.1386 17.3903 15.8605 17.8675C15.5825 18.3447 14.9702 18.5061 14.493 18.228L8.49304 14.728C8.01587 14.45 7.85445 13.8377 8.13251 13.3605Z"
    />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M15.8597 6.13228C16.138 6.60929 15.977 7.22163 15.5 7.5L9.50806 11.2274C9.03106 11.5057 8.41871 11.3447 8.14034 10.8677C7.86197 10.3907 8.023 9.77837 8.5 9.5L14.4919 5.77263C14.9689 5.49426 15.5813 5.65528 15.8597 6.13228Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'ShareIcon',
}
</script>
